
import React, { useEffect } from 'react';
import { useProducts } from '../../hooks/useProducts';

const GoogleTagInjector: React.FC = () => {
    const { analyticsSettings } = useProducts();
    const tagId = analyticsSettings?.googleTagId;

    useEffect(() => {
        if (!tagId) return;

        const isGTM = tagId.startsWith('GTM-');

        if (isGTM) {
            // GTM: check if already loaded (e.g. from index.html)
            const alreadyLoaded = document.querySelector(`script[src*="gtm.js?id=${tagId}"]`);
            if (alreadyLoaded) return;

            // Inject GTM script
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtm.js?id=${tagId}`;
            document.head.appendChild(script);
        } else {
            // GA4 (G-XXXXXXXXXX): gtag.js approach
            if (document.getElementById('google-tag-script')) return;

            const script1 = document.createElement('script');
            script1.id = 'google-tag-script';
            script1.async = true;
            script1.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
            document.head.appendChild(script1);

            const script2 = document.createElement('script');
            script2.id = 'google-tag-init';
            script2.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${tagId}');
            `;
            document.head.appendChild(script2);
        }
    }, [tagId]);

    return null;
};

export default GoogleTagInjector;
